import { Injectable, effect, inject, untracked } from '@angular/core';
import { of, firstValueFrom, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserProfileStore } from '../state/user-profile.store';
import { AuthService } from '@shared/auth/services/auth.service';
import { JwtTokenService } from '@shared/auth/services/jwt-token.service';
import { Endpoints } from '@core/constants/endpoints.constant';
import { HttpService } from '@core/services/http.service';
import { UserInfoResponse } from '../domain/profile.response';

@Injectable({ providedIn: 'root' })
export class ProfileAutoLoaderService {
  private readonly _http = inject(HttpService);
  private readonly _userProfileStore = inject(UserProfileStore);
  private readonly _authService = inject(AuthService);
  private readonly _jwtTokenService = inject(JwtTokenService);

  constructor() {
    effect(async () => {
      const loggedIn = this._authService.isAuthenticated();
      const access = this._jwtTokenService.getAccessToken();

      if (!loggedIn || !access) {
        this._userProfileStore.clear();
        return;
      }
      const profileStore = untracked(() => this._userProfileStore.profile());
      if (profileStore) return;

      const profile = await firstValueFrom(this.getProfile().pipe(catchError(() => of(null))));
      this._userProfileStore.set(profile);
    });
  }

  getProfile(): Observable<UserInfoResponse> {
    return this._http.get(Endpoints.accounts.userInfo);
  }
}
